import { Scalars } from "@octokit/graphql-schema";
import { Maybe } from "graphql/jsutils/Maybe";
import { UpdateManualTaskInput } from "../../graphql/generated/schema-types";

export class ManualTaskInputStub implements UpdateManualTaskInput {
  documentationUrl: Maybe<Scalars["String"]>;
  name: Maybe<Scalars["String"]>;
}
